// import store from '@/store/store'

let is_allowed = {
  'dashboard-analytics': false,
  'manage_paths-paths': false,
  'manage_paths-typeOfPaths': false,
  'manage_paths-fees': false,
  'manage_paths-feeTypes': false,
  'manage_paths-packagings': false,
  'manage_purchase-purchase': false,
  'manage_inventory-traceabilities': false,
  'manage_inventory-agent': false,
  'manage_seasons-seasons': false,
  'manage_seasons-provisionalPrices': false,
  'manage_product-product': false,
  'manage_product-seedLoan': false,
  'manage_cooperatives-cooperatives': false,
  'manage_cooperatives-producers': false,
  'manage_store-store': false,
  'manage_store-rents': false,
  'manage_store-otherFees': false,
  'manage_store-storeOutlays': false,
  'manage_store-guardian': false,
  'manage_store-securityCharges': false,
  'settings-region': false,
  'settings-prefecture': false,
  'settings-canton': false,
  'settings-village': false,
  'users': false
};

/* {
  code: 'admin',
  libelle: 'Administrateur'
},
{
  code: 'dg',
  libelle: 'Directeur général'
},
{
  code: 'de',
  libelle: 'Directeur d\'exploitation'
},
{
  code: 'rsci',
  libelle: 'Agronome'
},
{
  code: 'agent',
  libelle: 'Agent'
} */

console.log(' ............................................................. response_data_user_role: entrer nav');

let response_data_user_role = localStorage.getItem('response_data_user_role');

console.log(' ............................................................. response_data_user_role: entrer nav', response_data_user_role);
console.log(' ............................................................. response_data_user_role: entrer nav');

if (response_data_user_role === 'admin' || response_data_user_role === 'dg' || response_data_user_role === 'rsci' || response_data_user_role === 'de') {
  is_allowed['dashboard-analytics'] = true;
  is_allowed['manage_paths-paths'] = true;
  is_allowed['manage_paths-typeOfPaths'] = true;
  is_allowed['manage_paths-fees'] = true;
  is_allowed['manage_paths-feeTypes'] = true;
  is_allowed['manage_paths-packagings'] = true;
  is_allowed['manage_purchase-purchase'] = true;
  is_allowed['manage_inventory-traceabilities'] = true;
  is_allowed['manage_inventory-agent'] = true;
  is_allowed['manage_seasons-seasons'] = true;
  is_allowed['manage_seasons-provisionalPrices'] = true;
  is_allowed['manage_product-product'] = true;
  is_allowed['manage_product-seedLoan'] = true;
  is_allowed['manage_cooperatives-cooperatives'] = true;
  is_allowed['manage_cooperatives-producers'] = true;
  is_allowed['manage_store-store'] = true;
  is_allowed['manage_store-rents'] = true;
  is_allowed['manage_store-otherFees'] = true;
  is_allowed['manage_store-storeOutlays'] = true;
  is_allowed['manage_store-guardian'] = true;
  is_allowed['manage_store-securityCharges'] = true;
  is_allowed['settings-region'] = true;
  is_allowed['settings-prefecture'] = true;
  is_allowed['settings-canton'] = true;
  is_allowed['settings-village'] = true;
  is_allowed['users'] = true;
}

if (response_data_user_role === 'agent') {
  /* console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log('response_data_user_role: ', response_data_user_role);
  console.log('response_data_user_role: ', store.state.AppActiveUser);
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- ');
  console.log(' ------------------------- response_data_user_role: ------------------------------------------- '); */

  is_allowed['dashboard-analytics'] = true;
  is_allowed['manage_paths-paths'] = true;
  is_allowed['manage_paths-fees'] = true;
  is_allowed['manage_purchase-purchase'] = true;
  is_allowed['manage_inventory-traceabilities'] = true;
  is_allowed['manage_inventory-agent'] = true;
  is_allowed['manage_product-seedLoan'] = true;
  is_allowed['manage_cooperatives-cooperatives'] = true;
  is_allowed['manage_cooperatives-producers'] = true;
  is_allowed['manage_store-store'] = true;
  is_allowed['manage_store-guardian'] = true;
  is_allowed['users'] = true;
}

let general_nav_bar = [] ;
let submenu = [] ;

if (is_allowed['dashboard-analytics']) {
  general_nav_bar.push(
    {
      url: '/dashboard',
      name: "Dashboard",
      slug: "dashboard-analytics",
      icon: "HomeIcon",
      i18n: "Dashboard",
    }
  );
}

submenu = [];
if (is_allowed['manage_paths-paths']) {
  submenu.push(
    {
      url: '/manage_paths/paths/0',
      name: "Trajets",
      slug: "manage_paths-paths",
    }
  );
}

if (is_allowed['manage_paths-typeOfPaths']) {
  submenu.push(
    {
      url: '/manage_paths/typeOfPaths',
      name: "Type de trajet",
      slug: "manage_paths-typeOfPaths",
    }
  );
}

if (is_allowed['manage_paths-fees']) {
  submenu.push(
    {
      url: '/manage_paths/fees',
      name: "Frais",
      slug: "manage_paths-fees",
    }
  );
}

if (is_allowed['manage_paths-feeTypes']) {
  submenu.push(
    {
      url: '/manage_paths/feeTypes',
      name: "Type de frais",
      slug: "manage_paths-feeTypes",
    }
  );
}

if (is_allowed['manage_paths-packagings']) {
  submenu.push(
    {
      url: '/manage_paths/packagings',
      name: "Colis",
      slug: "manage_paths-packagings",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des trajets",
      icon: "TruckIcon",
      submenu: submenu
    }
  );
}

submenu = [];
if (is_allowed['manage_purchase-purchase']) {
  submenu.push(
    {
      url: '/manage_purchase/purchase',
      name: "Achats",
      slug: "manage_purchase-purchase",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des achats",
      icon: "ShoppingBagIcon",
      submenu: submenu
    }
  );
}

// Gestion des stocks
submenu = [];
if (is_allowed['manage_inventory-traceabilities']) {
  submenu.push(
    {
      url: '/manage_inventory/traceabilities',
      name: "Entrée - sortie en magasin",
      slug: "manage_inventory-traceabilities",
    }
  );
}

if (is_allowed['manage_inventory-agent']) {
  submenu.push(
    {
      url: '/manage_inventory/agent',
      name: "Stock agent",
      slug: "manage_inventory-agent",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des stocks",
      icon: "ArchiveIcon",
      submenu: submenu
    }
  );
}

// Gestion des saisons
submenu = [];
if (is_allowed['manage_seasons-seasons']) {
  submenu.push(
    {
      url: '/manage_seasons/seasons',
      name: "Saison",
      slug: "manage_seasons-seasons",
    }
  );
}

if (is_allowed['manage_seasons-provisionalPrices']) {
  submenu.push(
    {
      url: '/manage_seasons/provisionalPrices',
      name: "Prix prévisionnel",
      slug: "manage_seasons-provisionalPrices",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des saisons",
      icon: "MoonIcon",
      submenu: submenu
    }
  );
}

submenu = [];
if (is_allowed['manage_product-product']) {
  submenu.push(
    {
      url: '/manage_product/product',
      name: "Produits",
      slug: "manage_product-product",
    }
  );
}

if (is_allowed['manage_product-seedLoan']) {
  submenu.push(
    {
      url: '/manage_product/seedLoan',
      name: "Prêts semences",
      slug: "manage_product-seedLoan",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des produits",
      icon: "ShoppingCartIcon",
      submenu: submenu
    }
  );
}

submenu = [];
if (is_allowed['manage_cooperatives-cooperatives']) {
  submenu.push(
    {
      url: '/manage_cooperatives/cooperatives',
      name: "Coopératives",
      slug: "manage_cooperatives-cooperatives",
    }
  );
}

if (is_allowed['manage_cooperatives-producers']) {
  submenu.push(
    {
      url: '/manage_cooperatives/producers',
      name: "Producteurs",
      slug: "manage_cooperatives-producers",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des coopératives",
      icon: "GlobeIcon",
      submenu: submenu
    }
  );
}
// ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
submenu = [];
if (is_allowed['manage_store-store']) {
  submenu.push(
    {
      url: '/manage_store/store',
      name: "Magasins",
      slug: "manage_store-store",
    }
  );
}

if (is_allowed['manage_store-rents']) {
  submenu.push(
    {
      url: '/manage_store/rents',
      name: "Loyer",
      slug: "manage_store-rents",
    }
  );
}

if (is_allowed['manage_store-otherFees']) {
  submenu.push(
    {
      url: '/manage_store/otherFees',
      name: "Autre Frais",
      slug: "manage_store-otherFees",
    }
  );
}

if (is_allowed['manage_store-storeOutlays']) {
  submenu.push(
    {
      url: '/manage_store/storeOutlays',
      name: "Type de Frais",
      slug: "manage_store-storeOutlays",
    }
  );
}

if (is_allowed['manage_store-guardian']) {
  submenu.push(
    {
      url: '/manage_store/guardian',
      name: "Gardiens",
      slug: "manage_store-guardian",
    }
  );
}

if (is_allowed['manage_store-securityCharges']) {
  submenu.push(
    {
      url: '/manage_store/securityCharges',
      name: "Frais gardiennage",
      slug: "manage_store-securityCharges",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Gestion des magasins",
      icon: "BoxIcon",
      submenu: submenu
    }
  );
}

// ####################################################################################################################################################################################
submenu = [];
if (is_allowed['settings-region']) {
  submenu.push(
    {
      url: '/settings/region',
      name: "Régions",
      slug: "settings-region",
    }
  );
}

if (is_allowed['settings-prefecture']) {
  submenu.push(
    {
      url: '/settings/prefecture',
      name: "Préfectures",
      slug: "settings-prefecture",
    }
  );
}

if (is_allowed['settings-canton']) {
  submenu.push(
    {
      url: '/settings/canton',
      name: "Cantons",
      slug: "settings-canton",
    }
  );
}

if (is_allowed['settings-village']) {
  submenu.push(
    {
      url: '/settings/village',
      name: "Villages",
      slug: "settings-village",
    }
  );
}

if (submenu.length) {
  general_nav_bar.push(
    {
      url: null,
      name: "Paramètres",
      icon: "SettingsIcon",
      submenu: submenu
    }
  );
}

if (is_allowed['users']) {
  general_nav_bar.push(
    {
      url: "/users",
      name: "Utilisateurs",
      slug: "users",
      icon: "UsersIcon",
    }
  );
}

export default general_nav_bar

